import { foyrAxios } from "./foyrAxios";

export const getAPIResponse = async (url) => {
	return new Promise((resolve, reject) => {
		foyrAxios
			.get(url)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
	});
};

export const postAPIResponse = async (url, obj) => {
	return new Promise((resolve, reject) => {
		foyrAxios
			.post(url, obj)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
	});
};

export const putAPIResponse = async (url, obj) => {
	return new Promise((resolve, reject) => {
		foyrAxios
			.put(url, obj)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
	});
};

export const deleteAPIResponse = async (url, obj) => {
	return new Promise((resolve, reject) => {
		foyrAxios
			.delete(url, obj)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
	});
};
